<template>
    <button class='btn' :type='buttonType' :class='classObj' :disabled='isDisabled' @click="handleClick($event, {'action': btnAction, 'value': btnTarget} )"><span>{{CTA}}</span></button>
</template>

<script>
    export default{
        name: 'Button',
        props:['btnTarget', 'type', 'btnClass', 'CTA', 'btnAction', 'disabled'],
        computed:{
            classObj(){
                return{
                    ['btn-' + this.$props.type]: this.$props.type,
                    [this.$props.btnClass]: this.$props.btnClass
                }
            },
            buttonType(){
                return (this.$props.btnAction == 'submit') ? 'submit' : 'button'  
            },
            isDisabled() { return this.$props.disabled || false },
        },
        methods:{
            handleClick(e, params){
                console.log('e: '+ e + ', action:' + params.action + ', value: '+params.value);
                switch(params.action){
                    case 'link': this.$router.push(params.value); break;
                    case 'submit' : break;
                    default: this.$emit(params.value, params.action)
                }
            }
        }
    }
</script>